import 'bootstrap/dist/css/bootstrap.min.css';
import { injectGlobal } from 'styled-components';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faTrophy } from '@fortawesome/free-solid-svg-icons';

library.add(faTrophy);

injectGlobal`
  * {
    margin:0;
    padding: 0;
    box-sizing: border-box;
    outline: 0;
    font-family: "Open Sans"
  }

  html, body, #root, .con#main.clean {
    height: 100%;
  }

  body {
    text-rendering: optimizeLegibility !important;
    -webkit-font-smoothing: antialiased !important;
    font-family: 'Open Sans', sans-serif;
  }

  /* input {
    display: block;
    width: 100%;
    height: 34px;
    padding: 6px 12px;
    font-size: 14px;
    line-height: 1.42857143;
    color: #555;
    background-color: #fff;
    background-image: none;
    border: 1px solid #ccc;
    border-radius: 4px;
    height: 40px;
    margin-bottom: 15px;
     &[type="checkbox"], &[type="radio"]{
      width: auto;
    }
  } */
  .form-check{
    text-align: left;
  }

  input, a, button{
    &.btn{
      cursor: pointer;
      transition: all 0.3s ease 0s;
      border: 0;
      color: #fff;
      margin-bottom: 0;
      font-weight: 400;
      text-align: center;
      vertical-align: middle;
      touch-action: manipulation;
      background-image: none;
      white-space: nowrap;
      padding: 6px 12px;
      font-size: 14px;
      line-height: 1.42857143;
      border-radius: 4px;
      user-select: none;
    }
  }
  input.form-control{
    height: 45px;
  }
  /* form{
    .checkbox {
      text-align: left;
      margin-bottom: 10px;
      margin-top: -10px;
      label {
        input[type="checkbox"], input[type="radio"] {
          margin-bottom: -29px;
        }
        p {
          margin-left: 20px;
        }
      }
    }
  } */


  .header-main {
    margin: 10px 0 30px 0;
  }

  .input-search {
    border: none !important;
  }
  .form-control:focus {
    border-color: #fff !important;
    outline: 0 !important;
  }

  .input-group-text {
    background-color: #fff !important;
    border: none !important;
  }
  .nav-link {
    color: #333 !important;
  }
  a.nav-link:hover {
    color: #F9BE00 !important;
    font-weight: bold;
  }

  h1.title-page {
    font-size: 22px;
    text-align: center;
  }

  .home-main {
    h1 {
      font-size: 22px;
      margin: 15px 0 0 10px;
    }
  }

  .main-newspapers {
    h1 {
      font-size: 23px;
      padding-bottom: 15px;
    }
  }

  .main-newspaper {
    h1 {
      font-size: 23px;
      padding-bottom: 15px;
    }
    h3 {
      font-size: 19px;
      padding-bottom: 15px;
      margin-top: 25px;
    }
  }

  .border-bottom-gray {
    border-bottom: 2px solid #ccc;
  }

  .home-banner {

  }

  .box-newspaper {
    padding: 12px;
    h2 {
      margin: 8px 0 0 0;
      font-size: 13px;
      font-weight:bold !important;
    }

    a {
      color: #000;
    }

    a:hover {
      color: #000;
    }

    .publicated-at {
      font-size: 13px;
    }

  }

  .box-newspaper-assinar {
    font-size: 13px;
    color: #333;
    width: 100%;
    padding: 12px;
    text-align:center;
    background-color: #eee;
    border: 1px solid #ccc;

    h2 {
      font-size: 17px;
    }
    .valorSemanal {
      font-size: 20px;
      font-weight: bold;
    }
  }

  .footer-main {
    padding: 40px 0 40px 0;
    border-top: 3px solid #ddd;
    font-size: 12px;

    h2 {
      font-size: 16px;
    }

    a {
      font-weight: bold;
      color: #000;
    }
  }
  .footer-right {
    text-align: right;
  }

  .header {

  }

  a {
    border-bottom: none !important;
  }

  .nav-link {
    color: #000;
    text-transform: lowercase;
  }

  .text-box {
    font-size: 13px;
    h1 {
      font-size: 26px;
      text-align: center;
    }
    h2 {
      font-size: 18px;
    }
    ul {
      margin-left: 20px;
    }
  }

  @media (max-width: 575.98px) {
    .footer-left {
      text-align: center;
    }
    .footer-right {
      text-align: center;
    }
  }

  .list-group a {
    color: #333;
    font-size: 13px;
  }

  .list-group a:hover {
    color: #F9BE00;
    font-weight:bold;
  }

  a.list-group-item:hover {
    border-bottom: 1px solid rgba(0,0,0,.125) !important;
  }

  .title-underline {
    font-size: 23px;
    padding-bottom: 15px;
    border-bottom: 2px solid #ccc;
  }

  .btn.btn-success{
    height: 45px;
    font-size: 14px;
    margin-top: 20px;
    background-color: #28a745;
    &:hover {
      background-color: #32da58;
    }
  }
  .btn.btn-cancel{
    background-color: #dddddd;
    color: #000;
    &:focus{
      box-shadow: none;
    }
    &:hover {
      background-color: #b7b7b7;
    }
  }

`;



// WEBPACK FOOTER //
// ./src/assets/styles/style.js